'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _logger = require('@wh/logger');

var _logger2 = _interopRequireDefault(_logger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var logger = _logger2.default.getLogger('ui-translations');

/**
 * Inserts values to phrase under corresponding placeholders
 * @param {string} phrase Translated phrase eventually containing placeholders
 * @param {ParamsType} params Parameters to be inserted in phrase
 * @returns {string} Interpolated phrase
 */

var interpolate = function interpolate(phrase) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var interpolatedPhrase = phrase;

    (0, _keys2.default)(params).forEach(function (key) {
        var value = params[key];

        interpolatedPhrase = interpolatedPhrase.replace(new RegExp('{{' + key + '}}', 'g'), value);
    });

    return interpolatedPhrase;
};

/**
 * Chooses from singular or plural form and applies interpolation
 * @param {string} singular Phrase in singular form
 * @param {string} plural Phrase in plural form
 * @param {number} count Parameters to be inserted in phrase
 * @param {ParamsType} params Parameters to be inserted in phrase
 * @returns {string} Translated and interpolated phrase
 */
var chooseFormAndInterpolate = function chooseFormAndInterpolate(singular, plural) {
    var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    var _ref$count = _ref.count,
        count = _ref$count === undefined ? 1 : _ref$count,
        params = (0, _objectWithoutProperties3.default)(_ref, ['count']);

    var phrase = Math.abs(count) > 1 ? plural : singular;
    return interpolate(phrase, (0, _extends3.default)({
        count: count
    }, params));
};

/**
 * Provides higher order function to for providing translations
 * @param {TranslationsType} translations Object containing all available translations
 * @returns {Function} Function translating phrases
 */
var createTranslator = function createTranslator(translations) {
    return function (ctx) {
        var getTranslationKey = function getTranslationKey(idOfMsg) {
            return ctx + ':' + idOfMsg;
        };

        var getPhraseOrKey = function getPhraseOrKey(idOfMsg) {
            var msg = translations[ctx][idOfMsg];
            if (!msg) {
                if (msg === '') {
                    logger.warn(idOfMsg + ' phrase in ' + ctx + ' context is empty!');
                } else {
                    logger.warn('There is no ' + idOfMsg + ' phrase in ' + ctx + ' context!');
                }
                return getTranslationKey(idOfMsg);
            }
            return msg;
        };

        var recognizeUsage = function recognizeUsage(singularPhrase, msgPluralIdOrParams, params) {
            // t()(msg, { params })
            if ((typeof msgPluralIdOrParams === 'undefined' ? 'undefined' : (0, _typeof3.default)(msgPluralIdOrParams)) === 'object') {
                return interpolate(singularPhrase, msgPluralIdOrParams);
            }

            // t()(msg, msgPlural, { params })
            if (typeof msgPluralIdOrParams === 'string') {
                return chooseFormAndInterpolate(singularPhrase, getPhraseOrKey(msgPluralIdOrParams), params);
            }

            // t()(msg)
            return singularPhrase;
        };

        return function (msgId, msgPluralIdOrParams, params) {
            if (!ctx) {
                throw new Error('You must provide context to translator');
            }
            if (!translations[ctx]) {
                logger.warn('There is no ' + ctx + ' context in translations!');
                return getTranslationKey(msgId);
            }

            var singularPhrase = getPhraseOrKey(msgId);

            return recognizeUsage(singularPhrase, msgPluralIdOrParams, params);
        };
    };
};

exports.default = createTranslator;
//# sourceMappingURL=createTranslator.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/ui-translations/dist/main/createTranslator.js
// module id = 278
// module chunks = 0